import { data } from "jquery";

export const setLeadsData = (value) => {
  return {
    type: "SET_LEADS_DATA",
    payload: { data: value },
  };
};
export const setLeadCount = (value) => {
  return {
    type: "SET_LEAD_COUNT",
    payload: { data: value },
  };
};
export const setLeadPage = (value) => {
  return {
    type: "SET_LEAD_PAGE",
    payload: { data: value },
  };
};
export const setLeadLimit = (value) => {
  return {
    type: "SET_LEAD_LIMIT",
    payload: { data: value },
  };
};

export const setOpenLeadModal = (value) => {
  return {
    type: "SET_OPEN_LEAD_MODAL",
    payload: { data: value },
  };
};

export const setOpenLeadFollowUpModal = (value) => {
  return {
    type: "SET_OPEN_LEAD_FOLLOWUP_MODAL",
    payload: { data: value },
  };
};

export const setLeadInfo = (value) => {
  return {
    type: "SET_LEAD_INFO",
    payload: { data: value },
  };
};
export const setLeadFollowUps = (value) => {
  return {
    type: "SET_LEAD_FOLLOWUPS",
    payload: { data: value },
  };
};
export const setUserFollowUps = (value) => {
  return {
    type: "SET_USER_FOLLOWUPS",
    payload: { data: value },
  };
};

export const setLeadQuotations = (value) => {
  return {
    type: "SET_LEAD_QUOTATIONS",
    payload: { data: value },
  };
};

export const setOpenQuotationModal = (value) => {
  return {
    type: "SET_OPEN_QUOTATION_MODAL",
    payload: { data: value },
  };
};

export const setLeadLinkedTo = (value) => {
  return {
    type: "SET_LEAD_LINKED_TO",
    payload: { data: value },
  };
};
export const setOpenConverToSaleModal = (value) => {
  return {
    type: "SET_OPEN_CONVERT_TO_SALE_MODAL",
    payload: { data: value },
  };
};

export const setLeadStatics = (value) => {
  return {
    type: "SET_LEAD_STATICS",
    payload: { data: value },
  };
};